<template>
  <su-details
      :details="details"
      @previousPost="cateDetail"
      @nextPost="cateDetail"
      @favoriteArticle="favoriteArticle"
      @unfavoriteArticle="unfavoriteArticle"
      v-loading="loading"
      element-loading-text="正在加载..."
      element-loading-spinner="el-icon-loading"
  ></su-details>
</template>
<script>

import {favoriteArticle, getDetail, unfavoriteArticle} from "@/api/api";

export default {
  data() {
    return {
      loading: true,
      id: '',
      details: {},
    }
  },
  created() {
    //获取路由参数
    this.id = this.$route.query.id
    this.cateDetail()
  },
  methods: {
    // 收藏
    favoriteArticle() {
      favoriteArticle({
        new_id: this.id
      }).then(res => {
        if (res.status === 200) {
          this.cateDetail()
        }
      })
    },
    // 取消收藏
    unfavoriteArticle() {
      unfavoriteArticle({
        new_id: this.id
      }).then(res => {
        if (res.status === 200) {
          this.cateDetail()
        }
      })
    },
    // 详情
    cateDetail(e) {
      if (e) {
        this.id = e
      }
      getDetail({
        new_id: this.id,
      }).then(res => {
        this.loading = false
        if (res.status === 200) {
          this.details = res.data
        }
      }).catch(err => {
        this.loading = false
      })
    },
    // 上一篇
    previousPost() {

    },
    // 下一篇
    nextPost() {

    }
  }
}
</script>

<style scoped lang="scss">

</style>
